import React, { useState } from "react";
import classes from "./Details.module.css";
import { Text } from "components/common";
// const data = [
//   { label: "Name", value: "CEX Listed" },
//   { label: "Symbol", value: "USDC" },
//   { label: "Total Supply", value: "39,566,083,728.346" },
//   { label: "Holder Count", value: "2,927,908" },
//   { label: "Buy Tax.", value: "0%" },
//   { label: "Sell Tax.", value: "0%" },
//   { label: "Owner Address", value: "Renounced" },
//   { label: "Creator Balance", value: "2,394.34" },
//   { label: "Creator %", value: "0.000000%" },
//   { label: "LP Holder Count", value: "10" },
//   { label: "LP Total Supply", value: "42,289,024,276,976.55" },
//   { label: "Contract Type", value: "Proxy Contract" },
//   { label: "Open Source", value: "Yes" },
//   { label: "Honeypot Status", value: "Safe" },
//   { label: "Trading Status", value: "Fully Tradeable" },
//   { label: "CEX Listed", value: "Yes" },
//   { label: "DEX Presence", value: "Yes" },
// ];
const buttons = [];

const Details = ({ data }) => {
  const [activeButton, setActiveButton] = useState("Strong Buy");
  const handleClick = (button) => {
    setActiveButton(button);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        {data?.map((item, i) => (
          <div className={classes.item}>
            <Text primitive200 sm>
              {item.label}
            </Text>{" "}
            <Text primitive50 base>
              {item.value}
            </Text>
          </div>
        ))}
      </div>

      <div className={classes.buttonContainer}>
        {buttons?.map((button, i) => (
          <button
            key={i}
            className={`${classes.button} ${
              activeButton === button ? classes.active : ""
            }`}
            onClick={() => handleClick(button)}
          >
            {button}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Details;
